import { gql } from 'graphql-query-contracts';

export const deleteUnit = gql(`
  mutation DeleteUnit($propertyId: UUID!, $unitId: String!) {
    deleteUnit(propertyId: $propertyId, unitId: $unitId)
  }
`);
